import React, { useCallback, useMemo } from 'react';
import Button from '../Button';
import Icon from '../Icon';

interface ScrollToElementButtonProps {
  btnType: 'default' | 'primary' | 'secondary' | 'outlined';
  btnSize: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  selector: string;
  label: string | JSX.Element;
  fullwidth?: boolean;
  iconBefore?: string | JSX.Element;
  iconAfter?: string | JSX.Element;
}

const ScrollToElementButton = ({
  btnType,
  btnSize,
  selector,
  label,
  fullwidth = false,
  iconBefore,
  iconAfter,
}: ScrollToElementButtonProps) => {
  const onClick = () => {
    const elementTopPosition =
      document.querySelector(selector)?.getBoundingClientRect().top ?? 0;
    if (!elementTopPosition) return;

    const headerHeight =
      document.querySelector('#header')?.getBoundingClientRect().height ?? 0;

    window.scrollTo({
      top: elementTopPosition - headerHeight,
      behavior: 'smooth',
    });
  };

  const IconElement = useCallback(
    ({ icon }: { icon: string | JSX.Element }) => {
      if (typeof icon == 'string') {
        return <Icon name={icon} />;
      } else {
        return icon;
      }
    },
    []
  );

  return (
    <Button
      btnType={btnType}
      btnSize={btnSize}
      fullwidth={fullwidth}
      onClick={onClick}
    >
      {iconBefore && <IconElement icon={iconBefore} />}
      <span>{label}</span>
      {iconAfter && <IconElement icon={iconAfter} />}
    </Button>
  );
};

export default ScrollToElementButton;
